import { createApi as e } from "../../../node_modules/@reduxjs/toolkit/dist/query/react/rtk-query-react.modern.js";
import { CACHE_EXPIRATION_TIME_REFERENCE_BOOK as r } from "../constants.js";
const t = ({ baseUrl: t2, baseQuery: o }) => {
  const s = e({ reducerPath: "meteringNodeTypeApi", baseQuery: o({ baseUrl: `${t2}/metering-node-types` }), keepUnusedDataFor: r, endpoints: (e2) => ({ getMeteringNodeType: e2.query({ query: () => ({ url: "/" }) }) }) }), { useGetMeteringNodeTypeQuery: n } = s;
  return { meteringNodeTypeApi: s, useGetMeteringNodeTypeQuery: n };
};
export {
  t as initializeMeteringNodeTypeApi
};
//# sourceMappingURL=meteringNodeTypeApi.js.map
